import { useTranslation } from 'react-i18next';
import type { ObjectData } from '@os/doc';
import type { MediaResolver } from '../editor/lod';
import { safeHref } from '../text/sanitize';
import { useAssetUrl } from './useAssetUrl';

const hostOf = (url: string) => {
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return url;
  }
};

/** A link card: preview image (a board asset), title, description, site; the URL alone until (or unless) unfurled. */
export function LinkObject({ o, media }: { o: Extract<ObjectData, { type: 'link' }>; media: MediaResolver }) {
  const { t } = useTranslation();
  const thumb = useAssetUrl(media, o.thumbAssetId, 256);
  const href = safeHref(o.url);
  const host = hostOf(o.url);
  return (
    <div className="flex h-full w-full overflow-hidden rounded-xl border border-black/10 bg-white font-sans text-[#141414] shadow-sm">
      {thumb && <img src={thumb} alt="" draggable={false} className="pointer-events-none h-full w-1/3 shrink-0 select-none object-cover" />}
      <div className="flex min-w-0 flex-1 flex-col gap-1 p-3">
        <p className="truncate text-sm font-semibold">{o.title || host}</p>
        <p className="line-clamp-2 text-xs text-[#52525b]">{o.description || o.url}</p>
        <div className="mt-auto flex items-center justify-between gap-2 text-xs text-[#71717a]">
          <span className="truncate">{o.siteName || host}</span>
          {href && (
            <a href={href} target="_blank" rel="noopener noreferrer" data-canvas-ignore className="shrink-0 rounded-md border border-black/10 px-2 py-0.5 text-[#141414] hover:bg-black/5">
              {t('links.open')}
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
